import { useEffect, useState } from "react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";
import { openEnroll } from "@/lib/checkout";

const LINKS = [
  { id: "about", label: "Mentor" },
  { id: "inside", label: "Inside" },
  { id: "weeks", label: "The 8 Weeks" },
  { id: "pricing", label: "Pricing" },
  { id: "faq", label: "FAQ" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ink/85 backdrop-blur-md border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button
          data-testid="nav-logo-button"
          onClick={() => scrollToId("top")}
          className="cursor-pointer"
          aria-label="Back to top"
        >
          <Logo />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="font-mont text-[11px] font-bold uppercase tracking-[0.22em] text-white/55 transition-colors hover:text-bone"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-enroll-button"
          onClick={() => openEnroll()}
          className="bg-forest px-5 py-2.5 font-mont text-[11px] uppercase tracking-[0.22em] text-white transition-colors duration-300 hover:bg-[#2a6b50]"
        >
          Enroll Now
        </button>
      </div>
    </header>
  );
};

export default Nav;
